import React from 'react';
import {t} from '@lingui/core/macro';

import {promoCodeAPI, IPromoCode, ITariff} from 'entities/tariff';
import {getFormattedDate} from 'shared/lib/datetime';
import {iriToId} from 'shared/api/iriHelper';
import YesNo from 'shared/ui/YesNo/YesNo';

import AdminCrudRow from '../AdminList/AdminCrudRow/AdminCrudRow';
import {renderPublishAction} from '../AdminList/publishAction';
import PromoCodesModal from './PromoCodesModal';

interface IPromoCodesRowProps {
    item: IPromoCode;
    tariffs?: ITariff[];
}

const PromoCodesRow: React.FC<IPromoCodesRowProps> = ({item, tariffs}) => {
    const [togglePublish] = promoCodeAPI.useTogglePromoCodePublishMutation();

    const tariffName = tariffs?.find(
        tariff => String(tariff.id) === iriToId(item?.tariff),
    )?.name;

    const publishAction = renderPublishAction(
        item.published,
        {hide: t`Отключить`, show: t`Включить`},
        () => togglePublish({id: item.id, published: !item.published}),
    );

    return (
        <AdminCrudRow
            item={item}
            name={item.value}
            EditModal={PromoCodesModal}
            useDeleteMutation={promoCodeAPI.useDeletePromoCodeMutation}
            deleteTexts={{
                header: t`Удаление промокода`,
                title: t`Вы уверены, что хотите удалить промокод`,
                success: t`Промокод удалён`,
            }}
            extraActions={[publishAction]}
        >
            <td>{item?.id}</td>
            <td>{item?.value}</td>
            <td>{tariffName}</td>
            <td>{item?.period}</td>
            <td>{getFormattedDate(item?.expire_at, {format: 'DD.MM.YYYY'})}</td>
            <td>{item?.activations}</td>
            <td><YesNo condition={item?.published}/></td>
        </AdminCrudRow>
    );
};

export default PromoCodesRow;
